import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface UnauthorizedState {
  from?: string;
  requiredPermissions?: string[];
}

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();
  
  const state = location.state as UnauthorizedState;
  const fromPath = state?.from || 'unknown page';
  const requiredPermissions = state?.requiredPermissions || [];

  const handleGoBack = () => {
    window.history.back();
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: '600px',
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '20px' }}>🚫</div>
        
        <h1 style={{ color: '#dc3545', marginBottom: '20px' }}>
          Access Denied
        </h1>
        
        <p style={{ fontSize: '18px', marginBottom: '20px', color: '#6c757d' }}>
          You don't have permission to access <strong>{fromPath}</strong>
        </p>

        {requiredPermissions.length > 0 && (
          <div style={{ 
            backgroundColor: '#f8f9fa', 
            padding: '15px', 
            borderRadius: '5px', 
            marginBottom: '20px',
            textAlign: 'left'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#495057' }}>Required Permissions:</h4>
            <ul style={{ margin: 0, paddingLeft: '20px' }}>
              {requiredPermissions.map((permission, index) => (
                <li key={index} style={{ color: '#6c757d' }}>{permission}</li>
              ))}
            </ul>
          </div>
        )}

        {user && (
          <div style={{ 
            backgroundColor: '#e9ecef', 
            padding: '15px', 
            borderRadius: '5px', 
            marginBottom: '30px',
            textAlign: 'left'
          }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#495057' }}>Your Information:</h4>
            <p style={{ margin: '5px 0', color: '#6c757d' }}>
              <strong>Name:</strong> {user.employeeName}
            </p>
            <p style={{ margin: '5px 0', color: '#6c757d' }}>
              <strong>Email:</strong> {user.email}
            </p>
            <p style={{ margin: '5px 0', color: '#6c757d' }}>
              <strong>Your Permissions:</strong> {user.allPermissions?.join(', ') || 'None'}
            </p>
          </div>
        )}

        <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={handleGoBack}
            style={{
              padding: '10px 20px',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Go Back
          </button>
          
          <button
            onClick={handleGoToDashboard}
            style={{
              padding: '10px 20px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Go to Dashboard
          </button>
          
          <button
            onClick={handleLogout}
            style={{
              padding: '10px 20px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Logout
          </button>
        </div>

        <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#fff3cd', borderRadius: '5px' }}>
          <p style={{ margin: 0, color: '#856404', fontSize: '14px' }}>
            💡 <strong>Need access?</strong> Contact your system administrator to request the necessary permissions.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
